import { useExchangeStore } from '@/app/hooks/trade/exchangeStore';
import useTradeStore from '@/app/hooks/trade/tradeStore';
import { Input, message } from 'antd';
import {
  useContext,
  useEffect,
  useLayoutEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import { IconStar, IconStarFilled } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { BsSearch } from 'react-icons/bs';
import { ThemeContext } from '@/theme/ThemeProvider';
import { useFavourite } from '@/app/hooks';
import { COLORS } from '@/app/constants';
import { CButton } from '@/app/components/Common';
import { Row } from '@/styles/reactnative';
import { SubMenuFlex } from './style';
import * as MenuIcons from '@app/components/QBIT/Header/components/MenuIcons';
import { useDemoTradingStore } from '@/app/hooks/trade/demoTradingStore';

interface SubMenuListProps {
  handleMouseLeave: () => void;
}

const CoinList = ({ handleMouseLeave }: SubMenuListProps) => {
  const [isHover, setIsHover] = useState(false);
  const { isDemoMode } = useDemoTradingStore();
  const [targetHeight, setTargetHeight] = useState(0);
  const [search, setSearch] = useState('');

  const menuListRef = useRef<HTMLLIElement>(null);

  const navigate = useNavigate();
  const { data: favourites, toggleFavourite, isLoading } = useFavourite();
  const { theme } = useContext(ThemeContext);
  const { t } = useTranslation();
  const { EPs } = useExchangeStore();
  const { mutate: mutateTradeStore } = useTradeStore();

  const filteredEPs = useMemo(
    () =>
      EPs.filter((ep) => ep.pairs.toLowerCase().includes(search.toLowerCase())),
    [EPs, search]
  );

  const handleSubMenuMouseEnter = () => setIsHover(true);
  const handleSubMenuMouseLeave = () => setTimeout(() => setIsHover(false), 50);

  const handleClick = async (item: any) => {
    if (isLoading) return; // 로딩 중에는 클릭 방지
    await toggleFavourite(item);
  };

  useEffect(() => {
    if (!menuListRef.current) return;
    const height = menuListRef.current.offsetHeight;
    setTargetHeight(height);
  }, [menuListRef.current, isHover]);

  return (
    <SubMenuList
      onMouseEnter={handleSubMenuMouseEnter}
      onMouseLeave={handleSubMenuMouseLeave}
      $border={isHover}
      ref={menuListRef}
    >
      <Link
        onClick={() => {
          handleMouseLeave();
        }}
        to={'/trade/2'}
      >
        <SubMenuFlex>
          <div className="icon">
            <MenuIcons.USDTPerpetualsIcon />
          </div>
          <div>
            <h4 className="title">{t('usdtPerpetuals')}</h4>
            <p className="description">{t('perpetualContracts')}</p>
          </div>
        </SubMenuFlex>
      </Link>

      {/* {isHover && (
        <SubMenuContainer>
          <SearchContainer targetHeight={targetHeight}>
            <Input
              placeholder={t('search')}
              prefix={<BsSearch size={18} />}
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </SearchContainer>

          <CoinListContainer>
            <CoinListContent>
              {filteredEPs.map((ep) => {
                const isBookmarked = favourites?.find?.(
                  (f: any) => f?.ep_id === ep.id
                );
                const icon = isBookmarked ? (
                  <IconStarFilled size={20} style={{ color: COLORS.primary }} />
                ) : (
                  <IconStar color={theme.COLORS.textw} size={20} />
                );
                return (
                  <CoinItem
                    key={ep.id}
                    onClick={() => {
                      handleMouseLeave();

                      // 선택된 EP 찾기
                      const selected = EPs.find((e) => e.id === ep.id);

                      if (selected) {
                        // 상태 업데이트
                        mutateTradeStore({
                          ep_id: selected.id,
                          ...selected,
                        });

                        // isDemoMode 상태로 demo/real 구분
                        const basePath = isDemoMode ? '/demo-trade' : '/trade';
                        navigate(`${basePath}/${ep.id}`, { replace: true });
                      }
                    }}
                  >
                    <Row style={{ alignItems: 'center', gap: 10 }}>
                      <CoinImage src={ep.image} alt={ep.symbol} />
                      <CoinSymbol>{ep.pairs}</CoinSymbol>
                    </Row>
                    <CButton
                      icon={icon}
                      style={{
                        marginRight: 5,
                      }}
                      onClick={(e) => {
                        e.stopPropagation();
                        handleClick(ep);
                      }}
                    />
                  </CoinItem>
                );
              })}
            </CoinListContent>
          </CoinListContainer>
        </SubMenuContainer>
      )} */}
    </SubMenuList>
  );
};

export default CoinList;

const SubMenuList = styled.li<{ $border?: boolean }>`
  position: relative;
  z-index: 10998;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 5px;

  a {
    display: block;
    width: 100%;
    height: 100%;
    padding: 15.5px 24px;
    gap: 10px;
  }

  .title {
    font-size: 16px;
    font-weight: 700;
    color: ${({ theme }) => theme.text};
  }

  .description {
    margin-top: 5px;
    font-size: 14px;
    font-weight: 400;
    color: #b7b7b7;
  }

  &:hover {
    background-color: ${({ theme }) => theme.COLORS.DropdownHoverBg};
  }
`;

const SubMenuContainer = styled.div`
  overflow: hidden;
  position: absolute;
  top: -4px;
  right: -6px;
  transform: translateX(100%);
  width: 100%;
  height: auto;
  background-color: ${({ theme }) => theme.COLORS.subMenuHover};
  border: 1px solid ${({ theme }) => theme.COLORS.SubmenuBorder};
  border-radius: 8px;
  z-index: 10997;

  display: flex;
  flex-direction: column;

  .ant-input-affix-wrapper {
    height: 100%;
    background-color: ${({ theme }) => theme.COLORS.DropdownBg} !important;
    border: none !important;
    box-shadow: none !important;
    padding: 8px 12px;

    &:hover {
      border: none !important;
      box-shadow: none !important;
    }

    &:focus,
    &:focus-within {
      border: none !important;
      box-shadow: none !important;
      outline: none !important;
    }

    .ant-input {
      background-color: transparent !important;
      border: none !important;
      box-shadow: none !important;
      font-size: 15px;
      font-weight: 500;
      color: ${({ theme }) => theme.COLORS.itemTitle} !important;

      &:focus {
        outline: none !important;
        border: none !important;
        box-shadow: none !important;
      }

      &::placeholder {
        color: ${({ theme }) => theme.COLORS.descText} !important;
      }
    }

    .ant-input-prefix {
      color: ${({ theme }) => theme.COLORS.descText} !important;
      margin-right: 8px;
    }
  }
`;

const SearchContainer = styled.div<{ targetHeight: number }>`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
  border-bottom: 1px solid ${({ theme }) => theme.COLORS.SubmenuBorder};
  height: ${({ targetHeight }) => targetHeight}px;
  background-color: ${({ theme }) => theme.COLORS.DropdownBg};
`;

const CoinListContainer = styled.div`
  padding: 10px;
  background-color: ${({ theme }) => theme.COLORS.DropdownBg};
`;

const CoinListContent = styled.div`
  overflow-y: auto;
  max-height: 400px;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const CoinItem = styled.div`
  cursor: pointer;
  display: flex;
  gap: 10px;
  align-items: center;
  justify-content: space-between;

  padding: 12px 8px;
  margin-right: 8px;
  border-radius: 6px;

  &:hover {
    background-color: ${({ theme }) => theme.COLORS.DropdownBg};
  }
`;

const CoinImage = styled.img`
  width: 24px;
  height: 24px;
  border-radius: 50%;
`;

const CoinSymbol = styled.span`
  font-size: 14px;
  font-weight: 700;
  color: ${({ theme }) => theme.COLORS.textw};
`;
